import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryTransformations_ds_get_inventory_transformation_by_id_lookupcodeService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { inventory_transformation_id?: number, lookup_code?: string }): 
  Promise<{ result: { Id?: number, LookupCode?: string, WarehouseId?: number, Project?: { Id?: number, OwnerId?: number }, InventoryTransformationStatus?: { Id?: number, Name?: string } }[] }> 
  {
    let url = `${environment.backendUrl}api/InventoryTransformations/datasources/ds_get_inventory_transformation_by_id_lookupcode/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { inventory_transformation_id?: number, lookup_code?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, WarehouseId?: number, Project?: { Id?: number, OwnerId?: number }, InventoryTransformationStatus?: { Id?: number, Name?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/InventoryTransformations/datasources/ds_get_inventory_transformation_by_id_lookupcode/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { inventory_transformation_id?: number, lookup_code?: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, WarehouseId?: number, Project?: { Id?: number, OwnerId?: number }, InventoryTransformationStatus?: { Id?: number, Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransformations/datasources/ds_get_inventory_transformation_by_id_lookupcode/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      inventory_transformation_id?: number, lookup_code?: string    }) {
      return false;
    }
}
